module.exports = __webpack_public_path__ + "imgs/DCR.5322a1e9ac1076996022c79ee637c21e.png";